import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { AuthContainerComponent } from '../_components/auth-container.component';
import {
  FormControl,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';

import { AuthService } from '../_services/auth.service';
import { hasControlError } from '@hp-core/adapters/cybertron.adapter';
import { HlmInputDirective } from '@helipagos-ng/ui-input-helm';
import { HlmLabelDirective } from '@helipagos-ng/ui-label-helm';
import { Router } from '@angular/router';

@Component({
  selector: 'lib-forgot-password',
  standalone: true,
  imports: [
    CommonModule,
    AuthContainerComponent,
    TranslateModule,
    FormsModule,
    HlmInputDirective,
    ReactiveFormsModule,
    FormsModule,
    HlmLabelDirective,
    ReactiveFormsModule,
  ],
  templateUrl: './forgot-password.component.html',
})
export class ForgotPasswordComponent {
  private readonly authService = inject(AuthService);
  private readonly router = inject(Router);
  protected readonly mailControl = new FormControl('', [
    Validators.required,
    Validators.email,
  ]);

  protected isLoading = false;
  forgotPassword(value: string) {
    if (this.mailControl.valid) {
      this.isLoading = true;
      this.authService.forgotPaswordProcess(value).subscribe({
        next: () => {
          this.isLoading = false;
          console.log('forgot password success');
          this.router.navigate(['auth', 'validate-code']);
        },
        error: (error) => {
          this.isLoading = false;
          console.error('forgot password error', error);
        },
      });
    }
  }

  protected hasError(errorName: string = 'required'): boolean {
    return hasControlError(this.mailControl, errorName);
  }
}
